if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

window.addEventListener('quickAdd:itemAdded', function(event) {
  BasketChanged();
  HandleSideCart();
});

// call anytime the basket changes in any way
// this debounces calls the refreshes the DOM to match whatever is current
function BasketChanged() {
    if (window._basketChangedDebouncTimer != undefined) {
        clearTimeout(window._basketChangedDebouncTimer);
    }
    window._basketChangedDebouncTimer = setTimeout(refreshCart, 100);
}

function GetPostDataFromProperties(obj, properties) {
    properties.forEach(property => {
        obj[property[0]] = property[1];
    });
    return obj;
}

function getCurrentCart(cb)//Gets the current cart
{
    $.getJSON("/cart.json", function (response) {
        cb(response)
    });
}

function updateItem(key, properties, cb) {
    //updates a given cart line_item using properties passed to it in the format [["property1","value1"],["property2","value2"]]
    var update = { 'id': parseInt(key) };
    update = GetPostDataFromProperties(update, properties);

    $.post("/cart/change.js", update, function (response) {
      Shopify.getCart(function(cart) {
        cb(response);
      }.bind(this));
    }, "json");
}

function HandleQtyButtonClick(elem) {
    //functionality for adding 1 to quantity
    var item = elem.closest(".dm-cart-item");
    var qty = Number(item.querySelector(".dm-side-cart__line-item-quantity-amt").getAttribute("data-amt"));
    var id = item.getAttribute("data-line_item-id");

    if (elem.matches('[data-side-cart-item="increment"]')) {
        qty = [["quantity", qty + 1]];
    }
    else {
        qty = [["quantity", qty - 1]];
    }

    updateItem(id, qty, function (result) {
        BasketChanged();
    });
}

function penceToPound(pence) {
    const dmSideCart = document.querySelector('.dm-side-cart');
    const currencyFormat = dmSideCart.dataset.currencyFormat;

    const output = window.Shopify.formatMoney( pence, currencyFormat );
    console.log('PENCE TO POUND NEW: ', output);
    return output;

    /*
    var formatter = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    });

    return formatter.format(pence / 100)
    */
}

function refreshCart() {
    getCurrentCart(function (cart) {
        var cartDrawer = document.querySelector('[data-cart-drawer]')
        var itemlist = document.querySelector(".dm-side-cart__line-items");
        itemlist.innerHTML = "";
        var template = document.querySelector(".dm-cart-item-template");

        if (cart.item_count == 0) {
          cartDrawer.classList.add('dm-side-cart__popup--empty')
          BuildCartWithNoItems(cart);
        }
        else {
          cartDrawer.classList.remove('dm-side-cart__popup--empty')
          BuildCartWithItems(itemlist, template, cart);
        }

        UpdateSubTotal(cart);
        HandleCartCount(cart);
        HandleCartTitle(cart);
        HandleCartFreeShippingMessage(cart);
        HandleProductFreeShippingMessage(cart);

        window.dispatchEvent(
          new CustomEvent('cart:Refreshed', {
            detail: { cart },
          }),
        )
    });
}

function BuildCartWithItems(parent, target, cart) {
    function HandleCartItems(idx) {
        if (idx < cart.items.length) {
            var cartItem = cart.items[idx];
            GetShopifyItem(cartItem.url + ".js", "GET", function (product) {
                product = product.product;
                var item = BuildCartItem(target, cartItem, product);
                parent.appendChild(item);

                HandleCartItems(idx + 1);
            });
        }
        else {
            //Add event listeners
            $('[dm-side-cart-item="quantity"]').click(function (e) {
                e.preventDefault();
                HandleQtyButtonClick(e.currentTarget);
            });
        }
    }
    HandleCartItems(0);
}

function BuildCartWithNoItems(cart) {
    var cartBody = document.querySelector(".side-cart-body");
    var cartItemList = cartBody.querySelector(".dm-side-cart__line-items");

    cartItemList.classList.add('hidden')
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function BuildCartItem(target, item, product) {
    var cartItemsList = document.querySelector(".dm-side-cart__line-items");
    var copy = target.cloneNode(true);
    var variant = GetVariantFromLineItem(item, product);
    copy.setAttribute("data-line_item-id", item.variant_id);

    //image
    var image = copy.querySelector(".side-cart-img");
    image.setAttribute("src", item.featured_image.url);

    //title
    var titleEl = copy.querySelector(".dm-side-cart__line-item-title");
    titleEl.innerText = capitalizeFirstLetter(item.product_title);

    //to do: add compare at price
    var priceEl = copy.querySelector(".dm-side-cart__line-item-price");
    priceEl.innerHTML = GetItemPriceMarkup(item, variant);

    var optionWithValuesEl = copy.querySelector(".dm-side-cart__line-item-options");
    for (var i = 0; i < item.options_with_values.length; i++) {
        var p = document.createElement("p");
        p.setAttribute("class", "dm-side-cart__line-item-option");
        p.innerText = capitalizeFirstLetter(item.options_with_values[i].name.toLowerCase()) + ": " + capitalizeFirstLetter(item.options_with_values[i].value.toLowerCase());
        optionWithValuesEl.appendChild(p);
    }

    //qty
    var qtyEl = copy.querySelector(".dm-side-cart__line-item-quantity-amt");
    qtyEl.setAttribute("data-amt", item.quantity);
    qtyEl.innerText = item.quantity;

    let links = copy.querySelectorAll("[data-side-cart-item-link]");

    for (let link of links) {
        link.setAttribute('href', item.url)
    }

    //remove classes
    copy.classList.remove("hidden");
    copy.classList.remove("dm-cart-item-template");
    cartItemsList.classList.remove('hidden');

    return copy;
}

function GetVariantFromLineItem(item, product) {
    if (product.variants && product.variants.length) {
        for (var i = 0; i < product.variants.length; i++) {
            var variant = product.variants[i];
            if (variant.id == item.variant_id) {
                return variant;
            }
        }
    }
}

function GetItemPriceMarkup(item, variant) {
  if (variant) {
    if (variant.compare_at_price) {
      var compareAtPrice = Number(variant.compare_at_price * 100);

      if (compareAtPrice > item.price) {
        return "<span class='dm-side-cart__line-item-price-compare'>" + penceToPound(compareAtPrice) + "</span> " + penceToPound(item.price);
      }
      else {
        return penceToPound(item.price);
      }
    }
    else {
      return penceToPound(item.price);
    }
  }

  else {
    return penceToPound(item.price);
  }
}

function HandleCartCount(cart) {
    var counts = document.querySelectorAll(".cart-count");

    for (var x = 0; x < counts.length; x++) {
        if (cart.item_count > 0) {
          counts[x].classList.remove('visually-hidden')
        } else {
          counts[x].classList.add('visually-hidden')
        }
    }
}

function HandleCartTitle(cart) {
  const cartDrawerTitle = document.querySelector('.dm-side-cart__title')

  if (cart.item_count > 0) {
    cartDrawerTitle.innerHTML = window.theme.strings.cart.general.drawer_title.replace('{{ cart_total }}', cart.item_count)
  } else {
    cartDrawerTitle.innerText = window.theme.strings.cart.general.drawer_empty_title
  }
}

function UpdateSubTotal(cart) {
    var priceEl = document.querySelector(".dm-side-cart__subtotal-amount");
    priceEl.innerText = penceToPound(cart.total_price);
}

function HandleProductFreeShippingMessage(cart) {
    var freeShippingEl = document.querySelector(".product-free-shipping");
    if (!freeShippingEl) return;
    var freeShippingThreshold = Number(freeShippingEl.getAttribute("data-free-shipping-amount"));
    var curentProductPrice = Number(freeShippingEl.getAttribute("data-product-price"));
    var cartInclProductTotal = Number(cart.total_price + curentProductPrice);

    var freeShippingText = freeShippingEl.querySelector(".free-shipping-text");

    if (cartInclProductTotal >= freeShippingThreshold && cart.total_price < freeShippingThreshold) {
        freeShippingText.innerHTML = freeShippingText.getAttribute("data-free-shipping-progress-text");
        freeShippingEl.classList.remove('hide');
    } else if (cartInclProductTotal >= freeShippingThreshold && cart.total_price >= freeShippingThreshold) {
        freeShippingText.innerHTML = freeShippingText.getAttribute("data-free-shipping-qualify-text");
        freeShippingEl.classList.remove('hide');
    } else {
        freeShippingEl.classList.add('hide');
    }
}

function HandleCartFreeShippingMessage(cart) {
    var freeShippingText = document.querySelector(".dm-side-cart__shipping-amount");
    var freeShippingThreshold = Number(freeShippingText.getAttribute("data-free-shipping-amount"));
    var freeShippingIndicator = document.querySelector("[data-free-shipping-indicator]");

    if (cart.total_price > freeShippingThreshold) {
        freeShippingText.innerHTML = freeShippingText.getAttribute("data-free-shipping-qualify-text");
        freeShippingIndicator.classList.add('hide');
    }
    else {
        var amountLeft = freeShippingThreshold - cart.total_price;
        var message = freeShippingText.getAttribute("data-free-shipping-text");
        var freeShippingPercentage = cart.total_price * 100 / freeShippingThreshold;
        message = message.replace('[amount]', penceToPound(amountLeft));
        freeShippingText.innerHTML = message;
        freeShippingIndicator.classList.remove('hide');
        freeShippingIndicator.style.setProperty('--freeShippingPercentage', freeShippingPercentage + '%');
    }
}

function HandleCartUpsell(element) {
    var parent = SearchParentsFor(element, "dm-drawer-product-card");
    var select = parent.querySelector(".product-options");
    var id;

    for (var i = 0; i < select.options.length; i++) {
      var option = select.options[i];

      if (option.getAttribute("selected")) {
        id = option.value;
      }
    }

    if (!id) {
      var option = select.querySelector("option[ data-option-target='true' ]:not( [ disabled='disabled' ] )");
      id = option.value;
    }

    if (id === 'Choose size') {
      id = select.value
    }

    var post = { "id": id, "quantity": 1 };

    var emptyCartRecsItem = SearchParentsFor(element, "dm-side-cart__upsell-item")
    var cartRecsItem = element.closest("[data-pre-order-controller-external-el='push-cart-recs-quick-add']")
    let preOrderStatus = 'false';

    if (emptyCartRecsItem) {
      preOrderStatus = emptyCartRecsItem.getAttribute("data-item-is-pre-order");
    }
    if (cartRecsItem) {
      preOrderStatus = cartRecsItem.getAttribute("data-item-is-pre-order");
    }

    if (preOrderStatus === 'true') {
      post.properties = { "_pre_order_item": "true" };
    }

    DoAddToCart(post, function (response) {
      BasketChanged();
    });

}

function HandleCartQuickAddChange(select) {
    var option = select.options[select.selectedIndex];
    option.setAttribute("selected", "selected");
}

document.addEventListener('click', function (e) {
    if (e.target.matches('[dm-side-cart-item="quantity"]')) {
        e.preventDefault();
        HandleQtyButtonClick(e.target);
    }
    if (e.target.matches('.cart-drawer-toggle')) {
        e.preventDefault();
        HandleSideCart(e);
    }
    if (e.target.matches('[dm-side-cart-item="remove"]')) {
        e.preventDefault();
        var elem = e.target;
        var item = elem.closest(".dm-cart-item");
        var id = item.getAttribute("data-line_item-id");

        updateItem(id, [["quantity", 0]], function (result) {
            BasketChanged();
        });
    }
    if (e.target.matches('[dm-side-cart-item="quick-add"]')) {
        e.preventDefault();
        HandleCartUpsell(e.target);
    }
    if (e.target.matches('.dm-drawer-product-card__variant-wrapper select')) {
        e.preventDefault();
        HandleCartQuickAddChange(e.target);
    }
});
